// extracted by mini-css-extract-plugin
export var container = "_85-0";
export var error = "_85-9";
export var label = "_85-5";
export var light = "_85-6";
export var md = "_85-3";
export var sm = "_85-2";
export var thin = "_85-8";
export var thinBold = "_85-7";
export var vertical = "_85-4";
export var xs = "_85-1";